export default {
  vendorBudget: {
    title: "Debug Prestataire-Budget",
    buttons: {
      testIntegration: "Tester Intégration",
      testing: "Test en cours...",
      clear: "Effacer",
    },
    errors: {
      noUserOrEvent: "❌ Pas d'utilisateur ou d'événement sélectionné",
      noUser: "❌ Aucun utilisateur connecté",
      noEvent: "❌ Aucun événement sélectionné",
      testError: "❌ Erreur lors du test",
    },
    messages: {
      startTest: "🧪 Test complet de l'intégration prestataire-budget...",
      initialState: "📊 État initial des dépenses...",
      initialFound: "Initial: {{count}} dépenses trouvées",
      creatingVendor: "👨‍💼 Création d'un prestataire engagé avec prix...",
      vendorData: "Données prestataire: {{data}}",
      vendorCreated: "✅ Prestataire créé avec ID: {{id}}",
      waitingExpenses: "⏳ Attente de la création des dépenses...",
      checkingExpenses: "📊 Vérification des dépenses après création du prestataire...",
      afterCreation: "Après création: {{count}} dépenses trouvées",
      vendorExpenses: "Dépenses du prestataire: {{count}}",
      expenseDetail: "{{index}}. {{title}}: {{amount}}€ (payé: {{paid}})",
      checkingIds: "🔍 Vérification des IDs de dépenses dans le prestataire...",
      vendorFound: "Prestataire trouvé: {{name}}",
      expenseId: "expenseId: {{id}}",
      depositExpenseId: "depositExpenseId: {{id}}",
      notDefined: "non défini",
      vendorNotFound: "❌ Prestataire non trouvé après création",
      cleanup: "🧹 Nettoyage: suppression du prestataire test...",
      vendorDeleted: "✅ Prestataire test supprimé",
      finalCheck: "📊 Vérification finale des dépenses...",
      finalCount: "Final: {{count}} dépenses trouvées",
      cleanupSuccess: "✅ Nettoyage réussi: toutes les dépenses de test ont été supprimées",
      cleanupWarning: "⚠️ Attention: certaines dépenses de test pourraient subsister",
    },
    noLogs: "Aucun log pour le moment...",
  },
  contactsApi: {
    title: "Test de l'API Contact Picker",
    browser: "Navigateur",
    https: "HTTPS",
    apiStatus: "API Contact Picker",
    enabled: "Activé",
    disabled: "Désactivé",
    supported: "Supporté",
    notSupported: "Non supporté",
    technicalDetails: "Détails techniques",
    userAgent: "User Agent",
    platform: "Platform",
    language: "Language",
    cookiesEnabled: "Cookies activés",
    yes: "Oui",
    no: "Non",
    testButton: "Tester l'accès aux contacts",
    testing: "Test en cours...",
    error: "Erreur",
    contactsRetrieved: "Contacts récupérés ({{count}})",
    noName: "Sans nom",
    recommendations: "Recommandations",
    recommendation1: "• Utilisez Chrome sur Android ou Safari sur iOS pour de meilleurs résultats",
    recommendation2: "• Assurez-vous que le site est en HTTPS",
    recommendation3: "• Autorisez l'accès aux contacts quand demandé",
    recommendation4: "• Cette API ne fonctionne que sur mobile dans la plupart des cas",
    errors: {
      notSupported: "L'API Contact Picker n'est pas supportée sur ce navigateur",
      unknown: "Erreur inconnue lors de l'accès aux contacts",
    },
    browserDetection: {
      chromeMobile: "Chrome Mobile",
      safariMobile: "Safari Mobile",
      chromeDesktop: "Chrome Desktop",
      safariDesktop: "Safari Desktop",
      firefox: "Firefox",
      edge: "Edge",
      unknown: "Navigateur inconnu",
    },
  },
}; 